// extracted by mini-css-extract-plugin
export var description = "article-videos-module--description--80448";
export var player = "article-videos-module--player--127b2";
export var root = "article-videos-module--root--70249";
export var videos = "article-videos-module--videos--a5f12";